import { render } from "./DetailedReportCardItem.vue?vue&type=template&id=5dda8c06&scoped=true"
import script from "./DetailedReportCardItem.vue?vue&type=script&lang=js"
export * from "./DetailedReportCardItem.vue?vue&type=script&lang=js"

import "./DetailedReportCardItem.vue?vue&type=style&index=0&id=5dda8c06&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dda8c06"]])

export default __exports__